import React, { useState } from "react";
import { Modal } from "../../atom/Modal";
import { FileUpload } from "../../atom/UploadFile";
import { Input } from "../../atom/Input";
import { useTranslation } from "react-i18next";

interface UploadTrainingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpload: (file: File, year: string, hours: string) => Promise<void>;
}

export const UploadTrainingModal: React.FC<UploadTrainingModalProps> = ({
  isOpen,
  onClose,
  onUpload,
}) => {
  const { t } = useTranslation();
  const [files, setFiles] = useState<File[] | null>(null);
  const [year, setYear] = useState("");
  const [hours, setHours] = useState("");

  const handleUpload = async () => {
    if (files && files.length > 0 && year && hours) {
      await onUpload(files[0], year, hours);
      setFiles(null);
      setYear("");
      setHours("");
      onClose();
    }
  };

  const handleClose = () => {
    setFiles(null);
    setYear("");
    setHours("");
    onClose();
  };

  return (
    <Modal
      isModalOpen={isOpen}
      closeModal={handleClose}
      title={t("Upload Professional Training")}
      subtitle={t("Upload your certificate")}
      secondButtonLabel={t("Upload")}
      secondButtonClick={handleUpload}
      isSecondButtonDisabled={!files || !year || !hours}
      firstButtonLabel={t("Cancel")}
      firstButtonClick={handleClose}
      contentClassName="w-[600px] pb-0"
      additionalClassName="w-fit !max-w-fit"
      content={
        <div className="flex flex-col gap-6">
          <div className="flex gap-4">
            <div className="flex-1">
              <p className="text-gray-600 font-medium mb-2">
                {t("Year")}
                <span className="text-red-500 ml-1">*</span>
              </p>
              <Input
                id="year"
                type="number"
                value={year}
                onChange={(e) => setYear(e.target.value)}
                placeholder={t("YYYY")}
                required={true}
              />
            </div>
            <div className="flex-1">
              <p className="text-gray-600 font-medium mb-2">
                {t("Hours")}
                <span className="text-red-500 ml-1">*</span>
              </p>
              <Input
                id="hours"
                type="number"
                value={hours}
                onChange={(e) => setHours(e.target.value)}
                placeholder={t("e.g. 20")}
                required={true}
              />
            </div>
          </div>
          <FileUpload
            label={t("Certificate")}
            files={files}
            allowedTypes=".jpg,.pdf"
            setFiles={(files) => setFiles(files as File[])}
            disabled={false}
            fileName={t("Upload document")}
          />
        </div>
      }
    />
  );
};
